import { useTheme as _useTheme } from '@mui/material/styles'
import type { MergedThemes } from 'd2/types'

const useTheme: () => MergedThemes = _useTheme
export default useTheme
